import { withDevtools } from '@angular-architects/ngrx-toolkit';
import {
  EmptyFeatureResult,
  SignalStoreFeature,
  signalStoreFeature,
  SignalStoreFeatureResult,
  type,
} from '@ngrx/signals';
import { environment } from '../../../environments/environment';

export const withDevtoolsStub = <Input extends SignalStoreFeatureResult>(
  _name: string,
): SignalStoreFeature<Input, EmptyFeatureResult> =>
  signalStoreFeature(type<Input>(), (store) => store);

const isDevMode = environment.production === false;

export const storeWithDevtools = <Input extends SignalStoreFeatureResult>(
  name: string,
): SignalStoreFeature<Input, EmptyFeatureResult> =>
  isDevMode ? withDevtools(name) : withDevtoolsStub(name);